var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
var noteForPathContext = createContext({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setNoteId: function () { },
});
export var NoteForPathProvider = function (_a) {
    var children = _a.children;
    var noteId = useParams().noteId;
    var navigate = useNavigate();
    var _b = useState(), newlyCreatedNoteId = _b[0], setNewlyCreatedNoteId = _b[1];
    var setNoteId = function (id, appointmentIdForPath) {
        navigate("/appointment/".concat(appointmentIdForPath, "/note/").concat(id), { replace: true });
        setNewlyCreatedNoteId(id);
    };
    return (_jsx(noteForPathContext.Provider, __assign({ value: { noteId: noteId || newlyCreatedNoteId, setNoteId: setNoteId } }, { children: children })));
};
export var useNoteForPathContext = function () {
    var ctx = useContext(noteForPathContext);
    if (ctx === undefined) {
        throw new Error('useNoteForPathContext must be used within a NoteForPathProvider');
    }
    return ctx;
};
